import { FunctionComponent } from "react";
import { Navigate, useLocation } from "react-router-dom";
import useAuthSnapshot from "../hooks/useAuthSnapshot";
import Signin from "../pages/Signin";
import { authenticatedHomePath } from "./homePath";

export { authenticatedHomePath } from "./homePath";

const Home: FunctionComponent = () => {
  const { isAuthenticated, isAcmiClient, isRefuelEuReader } = useAuthSnapshot();
  const location = useLocation();
  const journeyLog = new URLSearchParams(location.search).get("journeyLog");

  if (isAuthenticated) {
    const target = !isAcmiClient && !isRefuelEuReader && journeyLog && /^jl_[a-f0-9]{32}$/.test(journeyLog)
      ? `/ops/journey-logs/${journeyLog}` : authenticatedHomePath(isAcmiClient, isRefuelEuReader);
    return <Navigate to={target} replace />;
  }
  return <Signin />;
};

export default Home;
